import { baseServiceInvoiceSchema } from "@redotech/redo-model/billing/service-invoice";
import { z } from "zod";

export const getFinalizedServiceInvoices = {
  input: z.null(),
  output: z.array(baseServiceInvoiceSchema),
};
